import { defineStore } from 'pinia';
import { SITE_STATUS } from '@/constant';
import { ref } from 'vue';

const forbiddenModalStore = defineStore('forbidden-modal', () => {
  const visible = ref(false);

  const hide = () => {
    visible.value = false;
  };

  const show = () => {
    if (SITE_STATUS.DISABLE) {
      visible.value = true;
    }
  };

  return { visible, hide, show };
});

export default forbiddenModalStore;
